import { useUpdatePassword } from '@/hooks/requests/useAuth';
import { Dialog, DialogContent, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import showToast from '@/utils/toast';
import { MESSAGES } from '@/constants/messages';
import Update2FAModal from './Update2FAModal';
import { UpdateProfileSettingsFormsProps } from '@/types/auth';
import UpdatePasswordForm from '@/components/UpdatePasswordForm';
import { UpdatePasswordFields } from '@/types/common';

export default function UpdatePasswordModal({
  open,
  setOpen,
}: UpdateProfileSettingsFormsProps) {
  const [newPassword, setNewPassword] = useState('');
  const [open2FAModal, setOpen2FAModal] = useState(false);
  const { updatePassword, isPending: updatePasswordLoading } =
    useUpdatePassword();

  async function handleMobileOtpStep(currentPassword: string) {
    const response = await updatePassword(
      {
        oldPassword: currentPassword,
        newPassword: newPassword,
      },
      {
        onError: () =>
          showToast({
            type: 'error',
            data: { content: MESSAGES.genericError },
          }),
      },
    );

    if (!response.oldPasswordValidationStatus) {
      showToast({
        type: 'error',
        data: {
          content: 'Current Password is incorrect',
        },
      });
    }

    if (!response.success) {
      showToast({ type: 'error', data: { content: MESSAGES.genericError } });
      return;
    }

    showToast({
      type: 'success',
      data: { content: 'Your password has been successfully updated' },
    });
    setOpen(false);
  }

  async function handleSubmit(data: UpdatePasswordFields) {
    setOpen2FAModal(true);
    setNewPassword(data.password);
  }

  return (
    <Dialog fullWidth open={open} onClose={() => setOpen(false)}>
      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="h5" component="h1">
            Update Your Password
          </Typography>
          <UpdatePasswordForm
            isLoading={updatePasswordLoading}
            handleSubmit={handleSubmit}
          />
          <Update2FAModal
            open={open2FAModal}
            setOpen={setOpen2FAModal}
            afterSuccessCallback={handleMobileOtpStep}
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
